export default __webpack_public_path__ + "static/featuredImage-2f00b3eb888d3e6d7eb84d16b92249ec.webp";